import React from "react";
import Breadcrumb from "../components/breadcrumb/Breadcrumb";

const reasons = [
  {
    number: "01",
    title: "Learn by doing",
    text: "Build practical projects that turn new ideas into skills you can use with confidence.",
  },
  {
    number: "02",
    title: "Guidance that fits",
    text: "Get clear lessons and support designed for different goals, starting points, and learning speeds.",
  },
  {
    number: "03",
    title: "Skills for what is next",
    text: "Explore relevant digital skills that help you grow at school, at work, or in your own venture.",
  },
  {
    number: "04",
    title: "Supportive community",
    text: "Learn alongside peers and mentors who help you stay motivated and accountable.",
  },
];

const WhyChooseUsPage = () => {
  return (
    <>
      <Breadcrumb current="Why Choose Us" />
      <section className="py-5" aria-label="Why choose us page">
        <div className="container">
          <div className="text-center mb-5">
            <h1 className="fw-bold mb-3">Why Choose Us?</h1>
            <p className="mx-auto" style={{ maxWidth: "700px" }}>
              A practical path from curiosity to capability, built for ambitious learners who want real-world skills and lasting confidence.
            </p>
          </div>

          <div className="row g-4">
            {reasons.map((reason) => (
              <div className="col-md-6 col-lg-3" key={reason.number}>
                <div className="card h-100 bg-dark border-3 shadow-sm p-4">
                  <span className="d-inline-block mb-3 fw-bold text-primary" style={{ fontSize: "1.5rem" }}>
                    {reason.number}
                  </span>
                  <h3 className="h4 fw-bold mb-3">{reason.title}</h3>
                  <p className="mb-0 text-muted">{reason.text}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
};

export default WhyChooseUsPage;
